// TODO: migrate all GA/fb tracking methods here & add tests

const GA = {
  conversionSignUp: once(() => {
    if (typeof gtag_report_conversion_signup !== 'undefined') {
      window.gtag_report_conversion_signup();
    }
  })
};

const FB_OLD_PIXEL = {
  completeRegistration: once(() => {
    if (typeof fb_pixel_code_CompleteRegistration !== 'undefined') {
      window.fb_pixel_code_CompleteRegistration();
    }
  })
};

const FB_SHOPIFY_PIXEL = {
  completeFreeRegistration: once(() => {
    if (typeof window.fb_pixel_shopify_FreeSignup_CompleteRegistration === 'function') {
      window.fb_pixel_shopify_FreeSignup_CompleteRegistration();
    }
  })
};

export async function trackSignupCompletion(planId, hasInviteToken) {
  try {
    const pixels = [GA.conversionSignUp, FB_OLD_PIXEL.completeRegistration];

    if (planId === 'free' && hasInviteToken !== true) {
      // eslint-disable-next-line
      console.debug('firing free signup complete registration pixel');
      pixels.push(FB_SHOPIFY_PIXEL.completeFreeRegistration);
    }
    // build in a delay so the pixel has time to reach its destination before the page gets redirected
    await delay(() => pixels.map((pixel) => pixel()), 500);
  } catch (e) {
    // eslint-disable-next-line
    console.error('Unable to fire free signup complete registration pixel', e);
  }
}

/**
 * Fire callback function and build in some delay before the promise is resolved. If the callback throws the promise will
 * be rejected immediately.
 *
 * NOTE: This does not wait for the callback() to finish executing if the callback is async - It starts counting down
 * as soon as the callback() is called.
 *
 * @param callback
 * @param millis
 * @returns {Promise<unknown>}
 */
export async function delay(callback, millis) {
  return new Promise((resolve, reject) => {
    try {
      // TODO: wait for callback to finish before we start the timer?
      callback();
    } catch (e) {
      // eslint-disable-next-line
      console.error('DELAYED_FUNCTION_ERROR', e);
      reject('DELAYED_FUNCTION_ERROR');
    }
    window.setTimeout(() => {
      try {
        resolve();
      } catch (e) {
        reject(e);
      }
    }, millis);
  });
}

/**
 * it is important that pixels only fire once, especially if we are firing them from render() or lifecycle methods
 */
function once(fn) {
  let hasFired = false;
  return () => {
    if (!hasFired) {
      fn();
      hasFired = true;
    }
    // eslint-disable-next-line
    console.debug(`function: ${fn.name} has already executed once, so we are ignoring this call.`);
  };
}



// WEBPACK FOOTER //
// ./src/helpers/pixelHelper.js